import styled from 'styled-components';

export const UserDashboard = styled.section`
    display: flex;
    flex-flow: column nowrap;
    position: relative;
    width: 48.8%;
    padding: 2.325rem 2.625rem;
    background: var(--global-bg);
    margin: 1rem;
    border: 1px solid #707070;
    border-radius: 1.25rem;
    color: var(--main-color);
    max-height: auto;
    opacity: 1;
`;
